import { useState } from "react";
import { Text } from "./i18n";
import { useInterval } from "./useInterval";
import { TranslationKeys } from "./i18n/translations";

const MINUTE = 1000 * 60;
const HOUR = MINUTE * 60;
const DAY = HOUR * 24;

export const EventCountdown: React.FC = () => {
  const eventDateMillis = new Date(
    "2025-07-12T15:00:00.000000+01:00"
  ).getTime();
  const [nowMillis, setNowMillis] = useState(new Date(Date.now()).getTime());

  useInterval(() => {
    setNowMillis(new Date(Date.now()).getTime());
  }, 10000);

  const timeDiff = Math.max(eventDateMillis - nowMillis, 0);

  const daysRemaining = Math.floor(timeDiff / DAY);
  const hoursRemaining = Math.floor((timeDiff - daysRemaining * DAY) / HOUR);
  const minutesRemaining = Math.floor(
    (timeDiff - daysRemaining * DAY - hoursRemaining * HOUR) / MINUTE
  );

  return (
    <p>
      <span>{daysRemaining}</span>
      &nbsp;
      <span>
        <Text id={getTranslationForDays(daysRemaining)} />
      </span>
      &nbsp;
      <span>{hoursRemaining}</span>
      &nbsp;
      <span>
        <Text id={getTranslationForHours(hoursRemaining)} />
      </span>
      &nbsp;
      <span>{minutesRemaining}</span>
      &nbsp;
      <span>
        <Text id={getTranslationForMinutes(minutesRemaining)} />
      </span>
    </p>
  );
};

function getTranslationForDays(days: number): TranslationKeys {
  if (days === 0) {
    return "eventCountdown.days_plural";
  } else if (days === 1) {
    return "eventCountdown.days_singular";
  } else if (days >= 2 && days <= 4) {
    return "eventCountdown.days_2_4";
  } else {
    return "eventCountdown.days_plural";
  }
}

function getTranslationForHours(hours: number): TranslationKeys {
  if (hours === 0) {
    return "eventCountdown.hours_plural";
  } else if (hours === 1) {
    return "eventCountdown.hours_singular";
  } else if (hours >= 2 && hours <= 4) {
    return "eventCountdown.hours_2_4";
  } else {
    return "eventCountdown.hours_plural";
  }
}

function getTranslationForMinutes(minutes: number): TranslationKeys {
  if (minutes === 0) {
    return "eventCountdown.minutes_plural";
  } else if (minutes === 1) {
    return "eventCountdown.minutes_singular";
  } else if (minutes >= 2 && minutes <= 4) {
    return "eventCountdown.minutes_2_4";
  } else {
    return "eventCountdown.minutes_plural";
  }
}
